module.exports = __webpack_public_path__ + "3657bba91f2baa3dcee64b0a2994eee5.png";